import { createSlice, createAction } from '@reduxjs/toolkit';

import {
  PAYMENT_LINKS,
  BILLING_LINKS,
  DISPUTE_LINKS,
  CABOODLE_LINKS,
  ADMIN_LINKS,
} from 'components/Navbar/navigationItems';
import { SIDEBAR, COLLAPSE_SIDEBAR } from './types';
import { getMe } from '../auth';

export const initialState = {
  isCollapsed: false,
  paymentLinks: [],
  disputeLinks: [],
  billingLinks: [],
  caboodleLinks: [],
  adminLinks: [],
  navItemVisible: {
    billing: false,
    caboodle: false,
    admin: false,
  },
};

export const collapseSidebar = createAction(COLLAPSE_SIDEBAR);

const setPermissionsPerItem = (permissions, links, isSuperAdmin = false) => {
  const items = links.filter(
    (item) =>
      permissions.indexOf(item.value) > -1 ||
      (isSuperAdmin && item.visibleToSuperAdmin)
  );
  if (!items.length) return [];

  return items;
};

const sidebarSlice = createSlice({
  name: SIDEBAR,
  initialState,
  reducers: {
    setNavItemVisible: (state, { payload }) => {
      state.navItemVisible = { ...state.navItemVisible, ...payload };
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(collapseSidebar, (state, { payload }) => {
        state.isCollapsed = payload;
      })
      .addCase(getMe.fulfilled, (state, { payload }) => {
        if (payload.permissions?.data?.length) {
          const isSuperAdmin = payload.is_super_admin;
          const permissions = payload.permissions.data.map((item) => item.name);

          state.paymentLinks = setPermissionsPerItem(
            permissions,
            PAYMENT_LINKS
          );
          state.disputeLinks = setPermissionsPerItem(
            permissions,
            DISPUTE_LINKS
          );
          state.billingLinks = setPermissionsPerItem(
            permissions,
            BILLING_LINKS
          );
          state.caboodleLinks = setPermissionsPerItem(
            permissions,
            CABOODLE_LINKS
          );
          state.adminLinks = setPermissionsPerItem(
            permissions,
            ADMIN_LINKS,
            isSuperAdmin
          );
        } else {
          state.paymentLinks = initialState.paymentLinks;
          state.disputeLinks = initialState.disputeLinks;
          state.billingLinks = initialState.billingLinks;
          state.caboodleLinks = initialState.caboodleLinks;
          state.adminLinks = initialState.adminLinks;
        }
      });
  },
});

export const { setNavItemVisible } = sidebarSlice.actions;

export default sidebarSlice.reducer;
